import gql from 'graphql-tag';
import { convertFilterRequestUrl } from 'utils/utils';

export default ({ page, size, filter, sort }) => {
  const sortStr = sort ? `, sort: ${sort}` : '';
  const filterStr = filter ? `, filter: ${convertFilterRequestUrl(filter, ['status'])}` : '';
  const searchOperatorDispute = `searchOperatorDispute(page: ${page}, size: ${size}${sortStr}${filterStr})`;
  return gql`
    query {
      ${searchOperatorDispute} {
        id
        fileName
        billingDate
        originOperator
        destinationOperator
        filePath
        numberOfRecords
        status
        batchNum
        serviceType
        totalOriginMsg
        totalDestMsg
    }
  }
  `;
};
